// extracted by mini-css-extract-plugin
export default {"root":"VisuallyHidden-module--root--dd434"};